import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseNavigationService } from '@shared/utils/navigation';
import { BaseHelperComponent } from '../base-helper/base-helper.component';

@Component({
    selector: 'feature-page-layout-page-internal-server-error',
    templateUrl: './page-internal-server-error.component.html',
    styleUrls: ['./page-internal-server-error.component.css'],
    standalone: false
})
export class PageInternalServerErrorComponent extends BaseHelperComponent implements OnInit {
  constructor(public router: Router, _navigationService: BaseNavigationService) {
    super(_navigationService);
  }

  ngOnInit(): void {}
}
